import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EnvironmentBannerComponent } from './environment-banner.component';

@NgModule({
  imports: [CommonModule, EnvironmentBannerComponent],
  exports: [EnvironmentBannerComponent],
})
export class EnvironmentBannerModule {}
